var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 40,
    viewBox: "0 0 94 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 11.0053,
    fill: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6868 14.1039C24.4655 15.4248 22.9934 18.4771 22.4932 22.7996C22.2496 24.9042 21.7562 26.4379 20.841 27.9354C19.8405 29.5723 18.3199 30.9011 16.7603 31.5013C16.4043 31.6383 16.1494 31.7845 16.1937 31.8261C16.3131 31.9379 18.736 32.0355 19.6095 31.9637C20.6643 31.8769 22.5569 31.3374 23.3054 30.91C25.005 29.9394 26.3583 28.2412 27.0235 26.244C27.4876 24.8505 27.6484 24.009 27.8154 22.0983C28.0255 19.6952 28.551 17.8242 29.2603 16.4386C30.0034 14.987 31.4919 14.162 33.0157 13.5811C33.3661 13.4475 33.6044 13.3526 33.6009 13.3397C33.5909 13.3026 31.432 13.3397 30.1801 13.3397C29.123 13.2768 27.4694 13.6386 26.6868 14.1039Z",
    fill: "url(#paint0_linear_1860_5041)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0198 16.5562C21.0212 16.8595 21.0123 17.1012 21.0034 17.3467C20.9963 17.5421 20.7843 17.6581 20.6149 17.5605C20.5147 17.5028 20.4249 17.4288 20.3553 17.3365C20.2122 17.1469 19.9576 16.7778 19.7802 16.3425C19.7121 16.1755 19.647 16.0003 19.5852 15.8222C19.0651 14.324 18.7948 12.7484 18.6824 11.1665C18.6532 10.7556 18.6365 10.3454 18.6448 9.98646C18.6754 8.6515 18.6437 7.85635 19.083 6.59537L19.0872 6.58331C19.2641 6.0754 19.3032 5.96319 19.4454 5.58037C19.6338 5.13268 20.0416 5.34624 20.0686 5.61353C20.1026 5.95105 20.1312 6.2276 20.145 6.34513C20.4935 9.3143 20.4673 11.0021 20.8274 13.9699C20.9508 14.9866 21.0152 15.5434 21.0198 16.5562Z",
    fill: "url(#paint1_linear_1860_5041)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.715 16.6775C17.7809 16.9248 17.8252 17.124 17.8703 17.3264C17.9063 17.4874 17.7579 17.6274 17.5988 17.5839C17.5047 17.5581 17.4156 17.5169 17.339 17.4564C17.1817 17.3321 16.8951 17.0852 16.6573 16.7676C16.5661 16.6459 16.4755 16.5167 16.387 16.3846C15.6426 15.2724 15.0856 14.0439 14.6561 12.7764C14.5446 12.4472 14.4434 12.1158 14.3735 11.821C14.1135 10.7246 13.9179 10.0822 14.0073 8.95901L14.0082 8.94827C14.0442 8.49584 14.0522 8.39588 14.0865 8.053C14.1448 7.64729 14.5233 7.73458 14.6023 7.94704C14.7022 8.21532 14.7846 8.43499 14.821 8.52799C15.7393 10.8776 16.0782 12.2611 17.0058 14.6071C17.3235 15.4109 17.495 15.8516 17.715 16.6775Z",
    fill: "url(#paint2_linear_1860_5041)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4039 18.0379C15.5236 18.1974 15.6125 18.3301 15.703 18.4647C15.7749 18.5719 15.6838 18.748 15.5364 18.7881C15.4493 18.8117 15.3625 18.8212 15.2815 18.8101C15.115 18.7873 14.8064 18.73 14.5216 18.5959C14.4124 18.5444 14.3018 18.487 14.1922 18.4264C13.2704 17.9157 12.4791 17.229 11.7871 16.4535C11.6073 16.252 11.4359 16.0442 11.3006 15.8499C10.7975 15.1275 10.4656 14.7243 10.2546 13.8198L10.2526 13.8112C10.1677 13.4468 10.1489 13.3664 10.0905 13.087C10.0365 12.7483 10.3829 12.6405 10.505 12.7672C10.6591 12.9272 10.7859 13.058 10.8408 13.1126C12.2283 14.4938 12.8725 15.4004 14.2669 16.7746C14.7446 17.2454 15.0042 17.5049 15.4039 18.0379Z",
    fill: "url(#paint3_linear_1860_5041)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6381 19.864C14.8188 19.9484 14.9597 20.0236 15.1029 20.0999C15.2168 20.1605 15.2193 20.3588 15.1081 20.4635C15.0424 20.5254 14.9702 20.5747 14.8936 20.603C14.7359 20.6612 14.4367 20.7558 14.1223 20.7715C14.0017 20.7775 13.8771 20.779 13.7519 20.777C12.6982 20.7603 11.6768 20.5268 10.7012 20.1682C10.4478 20.075 10.1988 19.9723 9.98797 19.8646C9.20404 19.464 8.72143 19.2644 8.10965 18.5656L8.10379 18.5589C7.85738 18.2775 7.80293 18.2153 7.61997 17.9962C7.41294 17.7228 7.66778 17.4647 7.83513 17.5191C8.04645 17.5877 8.21981 17.6434 8.294 17.6658C10.1683 18.2315 11.1633 18.7282 13.0404 19.2844C13.6835 19.475 14.0346 19.5818 14.6381 19.864Z",
    fill: "url(#paint4_linear_1860_5041)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9866 21.9503C14.1366 21.974 14.2555 21.9994 14.3763 22.0251C14.4725 22.0456 14.5162 22.1916 14.4571 22.2928C14.4222 22.3526 14.3798 22.4045 14.3298 22.4418C14.2269 22.5186 14.0281 22.6526 13.8016 22.7315C13.7147 22.7618 13.6239 22.7895 13.5319 22.8149C12.758 23.0281 11.9619 23.0742 11.1727 23.018C10.9677 23.0035 10.7639 22.9808 10.587 22.9463C9.92908 22.8181 9.534 22.7739 8.93882 22.3884L8.93313 22.3847C8.69339 22.2294 8.64043 22.1951 8.4603 22.0724C8.25107 21.9146 8.38275 21.6692 8.5166 21.6736C8.68563 21.6791 8.82416 21.6831 8.88314 21.6838C10.3732 21.7007 11.2058 21.8547 12.6958 21.864C13.2063 21.8672 13.4857 21.8709 13.9866 21.9503Z",
    fill: "url(#paint5_linear_1860_5041)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6147 24.0344C14.7523 24.0104 14.8629 23.9962 14.9752 23.9816C15.0646 23.9701 15.137 24.0652 15.1085 24.1558C15.0916 24.2094 15.0664 24.2591 15.031 24.3004C14.9582 24.3852 14.8143 24.5385 14.6332 24.659C14.5637 24.7052 14.4902 24.7507 14.4151 24.7947C13.7833 25.1651 13.093 25.4189 12.3852 25.5958C12.2013 25.6418 12.0166 25.6815 11.8528 25.705C11.2437 25.7927 10.8856 25.8695 10.2721 25.751L10.2662 25.7498C10.0191 25.7021 9.96445 25.6915 9.77736 25.6512C9.5565 25.5932 9.61546 25.3767 9.73432 25.3429C9.88442 25.3003 10.0073 25.265 10.0594 25.2491C11.3752 24.8497 12.1441 24.7327 13.4582 24.3278C13.9084 24.189 14.1552 24.1146 14.6147 24.0344Z",
    fill: "url(#paint6_linear_1860_5041)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1806 25.3328C16.2582 25.2642 16.3231 25.2125 16.3889 25.16C16.4413 25.1182 16.534 25.1566 16.559 25.2301C16.5738 25.2736 16.5814 25.3175 16.5782 25.3595C16.5718 25.4456 16.5522 25.6061 16.4927 25.758C16.4699 25.8162 16.4441 25.8754 16.4165 25.9343C16.1849 26.4294 15.8594 26.866 15.4856 27.2559C15.3885 27.3572 15.2878 27.4545 15.193 27.5328C14.8403 27.8237 14.6451 28.0121 14.1904 28.1621L14.1861 28.1635C14.003 28.2239 13.9625 28.2373 13.8219 28.2801C13.6509 28.3235 13.5851 28.1514 13.6459 28.0831C13.7227 27.9968 13.7854 27.9259 13.8115 27.8953C14.4725 27.1216 14.9147 26.75 15.5719 25.973C15.7971 25.7068 15.9213 25.562 16.1806 25.3328Z",
    fill: "url(#paint7_linear_1860_5041)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.208 19.7615C19.2286 19.691 19.3285 19.691 19.3491 19.7615L19.5145 20.3276C19.6766 20.8825 20.043 21.3553 20.5399 21.6508C20.5688 21.668 20.5688 21.7099 20.5399 21.7271C20.043 22.0226 19.6766 22.4954 19.5145 23.0503L19.3491 23.6163C19.3285 23.6869 19.2286 23.6869 19.208 23.6163L19.0426 23.0503C18.8805 22.4954 18.5141 22.0226 18.0173 21.7271C17.9884 21.7099 17.9884 21.668 18.0173 21.6508C18.5141 21.3553 18.8805 20.8825 19.0426 20.3276L19.208 19.7615Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4236 21.6888C23.3757 21.6888 19.8211 12.4106 29.5209 12.4106M15.0615 31.3886C22.1707 25.9663 15.423 21.6888 18.1341 21.6888",
    stroke: "white",
    strokeWidth: 0.222222
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7564 29C53.3725 29 53.0366 28.9779 52.7486 28.9336C52.4543 28.8957 52.2048 28.8483 52 28.7914V26.3446C52.2048 26.3888 52.4255 26.4299 52.6623 26.4679C52.8926 26.5121 53.139 26.5342 53.4013 26.5342C53.7468 26.5342 54.0572 26.4679 54.3323 26.3351C54.6075 26.2086 54.825 25.9652 54.985 25.6048C55.145 25.2445 55.225 24.726 55.225 24.0495V11.0569H58.2004V24.0306C58.2004 25.2192 58.0116 26.177 57.6341 26.9041C57.2629 27.6375 56.7414 28.1686 56.0696 28.4974C55.4041 28.8325 54.6331 29 53.7564 29Z",
    fill: "#1B1B1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1256 24.922V11.0569H65.101V24.922H62.1256Z",
    fill: "#1B1B1B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0352 11.0569L75.265 24.922H72.0208L67.2602 11.0569H70.2644L72.9038 19.3077C72.9486 19.4468 73.0222 19.7092 73.1246 20.0948C73.227 20.4742 73.3293 20.8788 73.4317 21.3087C73.5405 21.7323 73.6141 22.0832 73.6525 22.3614C73.6909 22.0832 73.7581 21.7323 73.854 21.3087C73.9564 20.8851 74.0556 20.4837 74.1516 20.1043C74.254 19.7187 74.3275 19.4531 74.3723 19.3077L77.031 11.0569H80.0352Z",
    fill: "#1B1B1B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7942 24.922L89.7769 21.6217H84.6611L83.6437 24.922H80.4379L85.3905 11H89.0282L94 24.922H90.7942ZM89.0666 19.156L88.0492 15.9315C87.9852 15.7165 87.8988 15.4415 87.7901 15.1064C87.6877 14.765 87.5821 14.4204 87.4733 14.0727C87.3709 13.7187 87.2878 13.412 87.2238 13.1528C87.1598 13.412 87.0702 13.7345 86.955 14.1201C86.8462 14.4995 86.7407 14.8599 86.6383 15.2013C86.5359 15.5427 86.4623 15.7861 86.4175 15.9315L85.4097 19.156H89.0666Z",
    fill: "#1B1B1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1860_5041",
    x1: 14.9588,
    y1: 15.7825,
    x2: 27.2107,
    y2: 49.2786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1860_5041",
    x1: 19.2931,
    y1: 5.37519,
    x2: 39.8925,
    y2: 37.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1860_5041",
    x1: 13.9184,
    y1: 7.91799,
    x2: 37.5927,
    y2: 29.7435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1860_5041",
    x1: 9.91208,
    y1: 13.0609,
    x2: 33.6389,
    y2: 23.6523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1860_5041",
    x1: 7.45025,
    y1: 18.0572,
    x2: 33.3698,
    y2: 16.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1860_5041",
    x1: 8.34913,
    y1: 22.1538,
    x2: 26.9621,
    y2: 15.3924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1860_5041",
    x1: 9.69838,
    y1: 25.7417,
    x2: 23.1281,
    y2: 14.0415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1860_5041",
    x1: 13.8142,
    y1: 28.3726,
    x2: 18.2233,
    y2: 15.6604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5f4ad471b5fdb32ba0a3687b319152f2.svg";
export { ForwardRef as ReactComponent };